import { render, staticRenderFns } from "./RoleListView.vue?vue&type=template&id=14115df4&scoped=true"
import script from "./RoleListView.vue?vue&type=script&lang=js"
export * from "./RoleListView.vue?vue&type=script&lang=js"
import style0 from "./RoleListView.vue?vue&type=style&index=0&id=14115df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14115df4",
  null
  
)

export default component.exports